"use client";
import { registerStoryblokBridge as r } from "./storyblok-js.mjs";
import { useEffect as d, startTransition as l } from "react";
import { liveEditUpdateAction as a } from "./live-edit-update-action.mjs";
const s = () => typeof window > "u" ? !1 : typeof window.storyblokRegisterEvent < "u" && window.location.search.includes("_storyblok"), p = ({ story: e = null, bridgeOptions: i = {} }) => {
  if (!s())
    return null;
  const n = (t) => {
    t && l(() => {
      a({ story: t, pathToRevalidate: window.location.pathname });
    });
  }, o = (e == null ? void 0 : e.id) ?? 0;
  return d(() => {
    r(o, (t) => n(t), i);
  }, []), null;
};
export {
  p as default
};
